import '@fontsource/bebas-neue';
import '@fontsource/ibm-plex-sans-condensed/400.css';
import '@fontsource/ibm-plex-sans-condensed/600.css';
import '@fontsource/ibm-plex-sans-condensed/700.css';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ScrollToTop } from './components/ScrollToTop';
import { Toaster } from './components/ui/sonner';

const PortfolioPage    = lazy(() => import('./pages/PortfolioPage'));
const ForgeDemo        = lazy(() => import('./pages/ForgeDemo'));
const SeoulSignalPage  = lazy(() => import('./pages/SeoulSignalPage'));
const HaleMercerPage   = lazy(() => import('./pages/HaleMercerPage'));
const NorthwindPage    = lazy(() => import('./pages/NorthwindPage'));
const WhiteoutPage     = lazy(() => import('./pages/WhiteoutPage'));
const MirrorStatePage  = lazy(() => import('./pages/MirrorStatePage'));
const ShaggyClubPage   = lazy(() => import('./pages/ShaggyClubPage'));
const WillowerePage    = lazy(() => import('./pages/WillowerePage'));
const HighLonesomePage = lazy(() => import('./pages/HighLonesomePage'));
const MeridianAirPage  = lazy(() => import('./pages/MeridianAirPage'));
const FerroxPage       = lazy(() => import('./pages/FerroxPage'));
const SaintsNeedlesPage= lazy(() => import('./pages/SaintsNeedlesPage'));
const GraniteGablePage = lazy(() => import('./pages/GraniteGablePage'));
const DirtToDuskPage   = lazy(() => import('./pages/DirtToDuskPage'));
const RoomToGlowPage   = lazy(() => import('./pages/RoomToGlowPage'));
const ActionHubPage       = lazy(() => import('./pages/ActionHubPage'));
const MoleculeToTablePage = lazy(() => import('./pages/MoleculeToTablePage'));
const PhysioReboundPage   = lazy(() => import('./pages/PhysioReboundPage'));
const BarrelTimeWhiskyPage= lazy(() => import('./pages/BarrelTimeWhiskyPage'));
const MovingDayScrubPage  = lazy(() => import('./pages/MovingDayScrubPage'));
const NightWatch24Page    = lazy(() => import('./pages/NightWatch24Page'));
const SoundMasteredPage   = lazy(() => import('./pages/SoundMasteredPage'));
const TheProbeWallPage    = lazy(() => import('./pages/TheProbeWallPage'));

const Loading = () => (
  <div style={{
    background: '#0D0D0D', height: '100vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  }}>
    <span style={{
      fontFamily: "'Bebas Neue', Impact, sans-serif",
      color: 'rgba(232,223,208,0.25)',
      fontSize: '1.5rem', letterSpacing: '0.5em',
    }}>· · ·</span>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/"                    element={<PortfolioPage />} />
            <Route path="/demo/forge"          element={<ForgeDemo />} />
            <Route path="/demo/seoul-signal"   element={<SeoulSignalPage />} />
            <Route path="/demo/hale-mercer"    element={<HaleMercerPage />} />
            <Route path="/demo/northwind"      element={<NorthwindPage />} />
            <Route path="/demo/whiteout"       element={<WhiteoutPage />} />
            <Route path="/demo/mirror-state"   element={<MirrorStatePage />} />
            <Route path="/demo/shaggy-club"    element={<ShaggyClubPage />} />
            <Route path="/demo/willowmere"     element={<WillowerePage />} />
            <Route path="/demo/high-lonesome"  element={<HighLonesomePage />} />
            <Route path="/demo/meridian-air"   element={<MeridianAirPage />} />
            <Route path="/demo/ferrox"         element={<FerroxPage />} />
            <Route path="/demo/saints-needles" element={<SaintsNeedlesPage />} />
            <Route path="/demo/granite-gable"  element={<GraniteGablePage />} />
            <Route path="/demo/dirt-to-dusk"   element={<DirtToDuskPage />} />
            <Route path="/demo/room-to-glow"   element={<RoomToGlowPage />} />
            <Route path="/demo/action-hub"           element={<ActionHubPage />} />
            <Route path="/demo/molecule-to-table"    element={<MoleculeToTablePage />} />
            <Route path="/demo/physio-rebound"       element={<PhysioReboundPage />} />
            <Route path="/demo/barrel-time-whisky"   element={<BarrelTimeWhiskyPage />} />
            <Route path="/demo/moving-day-scrub"     element={<MovingDayScrubPage />} />
            <Route path="/demo/night-watch-24"       element={<NightWatch24Page />} />
            <Route path="/demo/sound-mastered"       element={<SoundMasteredPage />} />
            <Route path="/demo/the-probe-wall"       element={<TheProbeWallPage />} />
          </Routes>
        </Suspense>
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
